import * as React from 'react';
import styled, { css, useTheme } from 'styled-components/macro';
import { Button } from 'react-covideo-common';
import { useState } from 'react';
import { useCDK } from 'lib/hooks/useCdk';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

const Switch = styled.div<{ disabled?: boolean }>`
  box-sizing: border-box;
  height: 40px;
  border-radius: 6px;
  background-color: rgba(0, 27, 83, 0.05);
  display: flex;
  align-items: center;
  & > span {
    margin: 12px;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      > div {
        opacity: 0.5;
      }
    `}
`;

export type Value = {
  text: string;
  value: string;
  width?: string;
};
type Props = {
  defaultValue: string;
  onChange: (value: string) => void;
  values: Value[];
  skipConfirmation?: boolean;
  className?: string;
  disabled?: boolean;
};

export const ButtonSwitch = (props: Props) => {
  const {
    defaultValue,
    values,
    onChange,
    className,
    skipConfirmation = true,
  } = props;
  const { colors } = useTheme();
  const { t } = useTranslation();

  const { isCdkUser } = useCDK();
  const [value, setValue] = useState(defaultValue);

  return (
    <Switch
      {...(className && { className: className })}
      disabled={props.disabled}
    >
      {values.map(btn => {
        if (btn.value === value) {
          return (
            <div style={{ width: btn.width }} key={btn.value}>
              <Button
                text={i18n.exists(btn.text) ? t(btn.text) : btn.text}
                size='large'
                extendStyles={{
                  container: isCdkUser
                    ? {
                        minHeight: 36,
                        maxHeight: 36,
                        background: colors.white[100],
                        color: colors.neutral[60],
                        border: colors.white[100],
                      }
                    : {},
                }}
              />
            </div>
          );
        }
        return (
          <Button
            text={i18n.exists(btn.text) ? t(btn.text) : btn.text}
            variant='transparent'
            extendStyles={{
              container: {
                color: colors.neutral[60],
              },
            }}
            key={btn.value}
            onClick={() => {
              onChange(btn.value);
              if (skipConfirmation) setValue(btn.value);
            }}
          />
        );
      })}
    </Switch>
  );
};
